<template>
  <span
    :class="[
      'inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium ring-1 ring-inset',
      value ? 'bg-[#f0f4e8] text-[#3d5218] ring-[#5c7a2e]/20' : 'bg-slate-100 text-slate-600 ring-slate-500/20'
    ]"
  >
    {{ value ? yes : no }}
  </span>
</template>

<script>
export default {
  name: "OPFormalLabel",
  props: {
    value: {
      default: true
    },
    yes: {
      default: "Formalizado"
    },
    no: {
      default: "No formalizado"
    }
  }
};
</script>
